<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <!-- <transition name="loader">
      <loader v-show="flagLoading" />
    </transition> -->
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <mobile-menu
        :notifications="notifications"
        @showBillDetailFromNotify="showBillDetailFromNotify"
      ></mobile-menu>
      <template slot="links">
        <sidebar-item
          v-if="permission.includes('bill-management')"
          :link="{
            name: 'Quản lý đơn hàng',
            icon: 'receipt_long',
            path: '/bill-management',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="permission.includes('manage-products')"
          :link="{
            name: 'Quản lý sản phẩm',
            icon: 'store',
            path: '/manage-products',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="permission.includes('user-management')"
          :link="{
            name: 'Quản lý nhân viên',
            icon: 'assignment_ind',
            path: '/user-management',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="permission.includes('admin-management')"
          :link="{
            name: 'Quản lý admin',
            icon: 'admin_panel_settings',
            path: '/admin-management',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="permission.includes('customer-management')"
          :link="{
            name: 'Quản lý đại lý',
            icon: 'home_work',
            path: '/customer-management',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="permission.includes('warehouse-management')"
          :link="{
            name: 'Quản lý nhập kho',
            icon: 'account_balance',
            path: '/warehouse-management',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="permission.includes('news-managements')"
          :link="{
            name: 'Tin tức và khuyến mại',
            icon: 'perm_media',
            path: '/news-managements',
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar
        :notifications="notifications"
        @showBillDetailFromNotify="showBillDetailFromNotify"
      ></top-navbar>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="100" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import DAO from "../../../DAO";
import firebase from "@/services/firebase-init.js";
import Notifications from "./Notifications";
import { Loader } from "@/components";

export default {
  components: {
    Loader,
    TopNavbar,
    MobileMenu,
    ZoomCenterTransition,
    loadData: () => import("../../../components/Loader/LoadData.vue"),
  },
  computed: {
    ...mapGetters(["flagLoading"]),
  },
  created() {
    this.db = firebase.firestore();
    this.permission = localStorage.getItem("permission").split(",");
    if (firebase.messaging.isSupported()) {
      this.messaging = firebase.messaging();
      this.messaging.onMessage((payload) => {
        this.$messageSuccess("Bạn có đơn hàng mới");
      });
    }
    let bits = localStorage.getItem("bits");
    DAO.getCollectionFromFireStore(
      this.db,
      process.env.VUE_APP_ORDER + bits
    ).then((doc) => {
      doc.forEach((element) => {
        let temp = element.data();
        if (temp.status == 0) {
          this.notifications.push(temp);
        }
      });
    });
    let _this = this;
    this.$store.commit("GET_LIST_PRODUCT");
  },
  data() {
    return {
      db: "",
      messaging: null,
      notifications: [],
      permission: [],
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      isChangePw: false,
    };
  },
  methods: {
    showBillDetailFromNotify(e) {
      this.$store.dispatch("LOAD_NOTIFICATIONS", {
        notify: e,
        isShow: true,
      });
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.loader-enter-active,
.loader-leave-active {
  transition: opacity 0.5s;
}
.loader-enter, .loader-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
